export default __webpack_public_path__ + "static/media/secret.f9310f05.png";